<template>
  <NuxtLinkLocale
    :to="`/${currentGameSlug}/e-learning`"
    class="e_learning_banner t-white d-flex-row justify-start"
    :class="currentGameSlug"
  >
    <div
      class="d-flex-column gap-30 justify-start align-start flex-5 flex-md-10"
    >
      <h3 class="title-h3 font-family-1 f-w-600">
        {{ $t(`e_learning.title_1`) }}
        <span class="title"> {{ $t(`e_learning.title_2`) }} </span>,
        {{ $t(`e_learning.title_3`) }}
      </h3>

      <div class="d-flex-row gap-16 space-between flex-wrap">
        <div
          class="d-flex-column justify-start align-start banner_options"
          v-for="option in options"
          :key="option"
        >
          <component :is="option.icon" />
          <h5 class="font-family-1 body-l f-w-600 t-white">
            {{ option.title }}
          </h5>
          <p class="font-family-2 regular-m t-light">
            {{ option.description }}
          </p>
        </div>
      </div>

      <div class="arrow_right cursor-pointer">
        <h4
          class="t-white bold-s f-w-600 font-family-1 text white-space-no flex-4"
        >
          {{ $t("main.buy_now") }}
        </h4>
        <arrow-right />
      </div>
      <div class="d-flex-row">
        <img
          :src="`/images/e_learning_mobile.webp`"
          alt="Elearning banner image"
          class="banner_image_mobile"
        />
      </div>
    </div>
  </NuxtLinkLocale>
</template>

<script setup>
import CoachingIcon from "../icons/CoachingIcon.vue";
import HeadphonesIcon from "../icons/HeadphonesIcon.vue";
import LearnIcon from "../icons/LearnIcon.vue";
import ArrowRight from "../icons/ArrowRight.vue";
import { computed } from "vue";

const { t } = useI18n();
const { currentGameSlug } = useGameComposable();

const options = [
  {
    title: t("e_learning.option_1.title"),
    description: t("e_learning.option_1.description"),
    icon: CoachingIcon,
  },
  {
    title: t("e_learning.option_2.title"),
    description: t("e_learning.option_2.description"),
    icon: HeadphonesIcon,
  },
  {
    title: t("e_learning.option_3.title"),
    description: t("e_learning.option_3.description"),
    icon: LearnIcon,
  },
];
</script>
